import { CSSProperties, HTMLAttributes } from 'react';
import clsx from 'clsx';
import { useFocusRing } from 'react-aria/useFocusRing';
import { useHover } from 'react-aria/useHover';
import { mergeProps } from 'react-aria/mergeProps';
import styles from '@danske/sapphire-css/components/list/list.module.css';
import { useListItemContext } from './ListItemContext';

/**
 * Return props that applies interactive list item styles, and list item paddings, and signals list
 * item to disable the default padding, in favour of this wrapper.
 */
export function useListItemActionWrapper({
  isDisabled,
  style = {},
}: {
  isDisabled?: boolean;
  style?: CSSProperties;
}): { actionWrapperProps: HTMLAttributes<HTMLElement> } {
  const { focusProps, isFocusVisible } = useFocusRing();
  const { hoverProps, isHovered } = useHover({ isDisabled });
  const { isActionButtonHovered } = useListItemContext();

  return {
    actionWrapperProps: mergeProps(focusProps, hoverProps, {
      className: clsx(
        styles['js-focus'],
        styles['js-hover'],
        styles['sapphire-list__item--interactive'],
        {
          [styles['is-focus']]: isFocusVisible,
          [styles['is-hover']]: isHovered && !isActionButtonHovered,
        }
      ),
      style,
    }),
  };
}
